import axios from '../lib/axios'
import AuthenticationService from '../services/AuthenticationService'
import Store from '../store/Store'

const url = process.env.ZLICK_V2
export default {
  getProducts: async () => {
    if (!AuthenticationService.isInRole(['admin', 'telemarketing', 'support', 'analyst', 'manual_subs'])) throw new Error('Permission denied. Cannot get products')
    const products = await axios.get(url + '/products', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      }
    })
    return products.data.filter(p => p.activated)
  }
}



// WEBPACK FOOTER //
// ./src/services/ProductsService.js